import styled from 'styled-components';
import { Flexbox, UserChip } from '@ibinder/common-frontend';

export const TableWrapper = styled.div`
  margin: 0 1rem;
  > * th {
    border-bottom: 0.0625rem solid ${({ theme }) => theme.colors.discrete20};
  }
  > * th:nth-child(2) {
    text-align: left:
  }
  > * td {
    vertical-align: middle;
    padding-top: 0;
    padding-bottom: 0;
  }
  > * td:first-child, th:first-child {
    padding-top: 0;
    padding-left: 1rem;
  }
`;

export const ActionbarContent = styled(Flexbox)`
  justify-content: end;
  width: 100%;
`;

export const PopupButton = styled(Flexbox)`
  width: 100%;
  align-items: center;
  padding-right: 1rem;
  color: ${({ theme }) => theme.colors.primary};
`;

export const AddUsersHeader = styled.div`
  font-weight: ${({ theme }) => theme.fontStyles.extraSmallFont.fontWeight};
  font-size: ${({ theme }) => theme.fontStyles.extraSmallFont.fontSize}px;
  color: ${({ theme }) => theme.colors.discrete};
  padding-bottom: 1rem;
`;

export const UserChipListHeader = styled.div`
  font-weight: ${({ theme }) => theme.fontStyles.smallBoldFont.fontWeight};
  font-size: ${({ theme }) => theme.fontStyles.smallBoldFont.fontSize}px;
  color: ${({ theme }) => theme.colors.discrete};
  padding: 1rem 0;
`;

export const NoUsersAddedInfo = styled.div`
  font-weight: ${({ theme }) =>
    theme.fontStyles.extraExtraSmallFont.fontWeight};
  font-size: ${({ theme }) => theme.fontStyles.extraExtraSmallFont.fontSize}px;
  color: ${({ theme }) => theme.colors.discrete70};
  padding: 0;
`;

export const UserChipList = styled(Flexbox)`
  margin: 0 -0.375rem 0 -0.375rem;
`;

export const SelectedUserChip = styled(UserChip)`
  padding: 0 0.25rem;
  margin: 0 0.375rem 0.375rem 0.375rem;
  height: 2rem;
`;

export const LoadingWrapper = styled(Flexbox)`
  height: 3rem;
  width: 100%;
  align-items: center;
  justify-content: center;
  > * div.half-circle-spinner {
    height: 2rem;
    width: 2rem;
  }
  > * div {
    height: 2rem;
    width: 2rem;
  }
`;

interface UserWrapperProps {
  itemSelected: boolean;
}
export const UserWrapper = styled(Flexbox)<UserWrapperProps>`
  background-color: ${({ itemSelected, theme }) =>
    itemSelected ? theme.colors.discrete5 : 'white'};
  padding: 0.5rem;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.primary10};
  }
  justify-content: space-between;
`;

export const NoResultsFound = styled(Flexbox)`
  padding: 1rem;
  flex-direction: row;
  width: 100%;
`;
